// src/components/ProductManager.js
import React, { useState } from "react";
import { Box, FormControl, InputLabel, Select, MenuItem, Button, Chip } from "@mui/material";

// Use the provided region/tenor map
const regTnrMap = {
  "SPDA NY": ["3Y", "5Y", "7Y"],
  "SPDA NAT": ["3Y", "5Y", "7Y"],
  "SPDA NY SCP": ["3Y", "5Y", "7Y"],
  "SPDA SCP": ["3Y", "4Y", "5Y", "7Y"],
  "FIA NY": ["5Y", "7Y"],
  "FIA NAT": ["5Y", "7Y"],
  "FIA PP": ["5Y", "7Y", "10Y"],
  "FIA PP Max": ["5Y", "7Y", "10Y"],
  "PRT PLAN1808": ["70Y"],
  "GPP BBE 2025A": ["7Y"]
};

export default function ProductManager({ dynamicColumns, onAddProduct, onRemoveProduct }) {
  // Region options come from the keys of the mapping
  const regionOptions = Object.keys(regTnrMap);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedTenor, setSelectedTenor] = useState("");

  const handleRegionChange = (event) => {
    setSelectedRegion(event.target.value);
    setSelectedTenor(""); // reset tenor when region changes
  };

  const handleAdd = () => {
    if (selectedRegion && selectedTenor) {
      onAddProduct(selectedRegion, selectedTenor);
      setSelectedRegion("");
      setSelectedTenor("");
    }
  };

  return (
    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <FormControl sx={{ mr: 2, minWidth: 120 }}>
        <InputLabel id="region-label">Region</InputLabel>
        <Select
          labelId="region-label"
          value={selectedRegion}
          label="Region"
          onChange={handleRegionChange}
        >
          {regionOptions.map((region) => (
            <MenuItem key={region} value={region}>
              {region}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ mr: 2, minWidth: 120 }} disabled={!selectedRegion}>
        <InputLabel id="tenor-label">Tenor</InputLabel>
        <Select
          labelId="tenor-label"
          value={selectedTenor}
          label="Tenor"
          onChange={(e) => setSelectedTenor(e.target.value)}
        >
          {selectedRegion &&
            regTnrMap[selectedRegion].map((tenor) => (
              <MenuItem key={tenor} value={tenor}>
                {tenor}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <Button sx={{ backgroundColor: 'lightgrey', color: 'black', m:1}} onClick={handleAdd}>
        Add Product
      </Button>
      <Box sx={{ ml: 10, display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center', py: 1, px: 2, border: '1px solid #ccc', borderRadius: 1, minHeight: 40 }}>
        {dynamicColumns.map((col) => (
          <Chip
            key={col.field}
            label={col.headerName}
            onDelete={() => onRemoveProduct(col.field)}
            sx={{ 
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)'
              }
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
